export default "__VITE_ASSET__DhiyZ6df__"